import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Button from 'components/buttons/Button';
import AddIcon from '@material-ui/icons/Add';
import Dialog from 'components/modals/Dialog';
import EmailGoogleOauthCreate from './EmailGoogleOauthConfig/EmailGoogleOauthCreate';
import EmailMicrosoftOauthCreate from './EmailMicrosoftOauthConfig/EmailMicrosoftOauthCreate';
import EmailImapSmtpConfigCreate from './EmailImapSmtpConfig/EmailImapSmtpConfigCreate';
import EmailKnownImapConfigCreate from './EmailKnownImapConfig/EmailKnownImapConfigCreate';


class EmailConfigCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    onEmailCreateSuccess: PropTypes.func.isRequired,
    config: PropTypes.shape({
      emailBackend: PropTypes.string.isRequired,
    }).isRequired,
    accountEmailConfig: PropTypes.shape({
      email: PropTypes.string,
      sender_name: PropTypes.string,
      total_number_of_emails_per_day: PropTypes.number,
      delay_between_each_email_sent: PropTypes.number,
      is_primary: PropTypes.bool,
      password: PropTypes.string,
      imap_config: PropTypes.shape({
        username: PropTypes.string,
        password: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
      smtp_config: PropTypes.shape({
        username: PropTypes.string,
        password: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
    }),
  };

  static defaultProps = {
    className: '',
    accountEmailConfig: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  onEmailCreateSuccess = (emailConfig) => {
    this.toggle();
    this.props.onEmailCreateSuccess(emailConfig.data.email);
  };

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <React.Fragment>
        <Button
          type="button"
          variant="outlined"
          onClick={this.toggle}
          startIcon={<AddIcon />}
          fullWidth
        >
          Add email
        </Button>
        <div className={this.props.className}>
          <Dialog
            open={this.state.isOpen}
            onBackdropClick={this.toggle}
            size="extra-small"
          >
            <div className="mb-2">Select provider</div>
            <div>
              <div>
                <EmailGoogleOauthCreate
                  className="text-center"
                  accountId={this.props.accountId}
                  btnProps={{
                    variant: 'outlinedWhite',
                    fullWidth: true,
                    style: { justifyContent: 'flex-start' },
                  }}
                />
              </div>
              <div>
                <EmailMicrosoftOauthCreate
                  className="text-center"
                  accountId={this.props.accountId}
                  btnProps={{
                    variant: 'outlinedWhite',
                    fullWidth: true,
                    style: { justifyContent: 'flex-start' },
                  }}
                />
              </div>
              <div>
                <EmailKnownImapConfigCreate
                  className="text-center"
                  accountId={this.props.accountId}
                  onEmailCreateSuccess={this.onEmailCreateSuccess}
                  accessTypeLabel="Outlook"
                  accessType="imap_outlook"
                />
              </div>
              <div>
                <EmailImapSmtpConfigCreate
                  className="text-center"
                  accountId={this.props.accountId}
                  onEmailCreateSuccess={this.onEmailCreateSuccess}
                />
              </div>
            </div>
          </Dialog>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(
  connect(
    state => ({
      accountEmailConfig: state.accountEmailConfig,
      config: state.config,
    }),
    {},
  ),
  withNamespaces('common'),
)(EmailConfigCreate);
